import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import App from './App';
import { consumeSsoTokenFromUrl } from './sso';

async function bootstrap() {
  const result = await consumeSsoTokenFromUrl();
  if (result === 'error') {
    console.warn('[Przekroje SSO] sign-in failed - fallback do logowania recznego');
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

bootstrap();
